import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { noInternetMessage } from '../utils/popup-messages';

@Injectable({ providedIn: 'root' })
export class OfflineGuard implements CanActivate {
  private isToastDisplayed = false;
  constructor(private readonly _toast: ToastrService) {}
  canActivate(): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      if (!navigator.onLine) {
        if (!this.isToastDisplayed) {
          this._toast.error(`${noInternetMessage.errorMessage}`);
          this.isToastDisplayed = true;
          setTimeout(() => {
            this.isToastDisplayed = false;
          }, 5000);
        }
        subscriber.next(false);
        subscriber.complete();
      } else {
        subscriber.next(true);
        subscriber.complete();
      }
    });
  }
}
